import React from 'react';
import { IconButton } from "@mui/material";

export default function CancelButton({ label, icon, onClick }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '120px' }}>
      <IconButton className="delivery-zone-cancel-button" onClick={onClick}>
        {icon}
      </IconButton>
      <span style={{ marginTop: '10px', textAlign: 'center', fontSize: "15px", fontWeight: "600" }}>{label}</span>
    </div>
  );
}
